module.exports = __webpack_public_path__ + "static/media/logo.bc487749.svg";